/** mảng màu các theme
 *  chỗ này không thể đặt tên biến theo chuẩn được,
 *  vì design không theo hệ thống nên màu tại các theme ko theo quy tắc,
 */

export const THEMES_ARRAY = [
  //1
  {
    name: 'Default',
    nameComponent: 'DefaultTheme',
    value: 'default',
    color1: '#FFFFFF',
    color2: '#000000',
    color3: '#FFFFFF',
    color4: '#40ACDD',
    color5: '#FF8F1F',
    color6: '#EB4319',
    color7: '#FFEFDE',
    color8: '#FFFFFF',
    color9: '#C1C1C1',
    color10: '#EB4319',
    color11: '#FFFFFF',
    color12: '#000000',
    color13: '#FFFFFF',
    color14: 'rgba(0, 0, 0, 0.1)', // tapped
    color15: '#57B360', // icon check
    color16: '#FF8F1F', // Màu nút ở trạng thái active
    color17: '#F5F5F4',
    color18: 'rgba(0, 0, 0, 0.25)', // Màu khi nút ở trạng thái disabled. Có thể tái sử dụng
    color19: '#34D399',
    color20: '#FF8F1F', // Màu button dùng tại popup recommend
    colorText1: '#000000', // dùng khá nhiều nên mn chú ý nhé
    colorText2: '#FFFFFF', // Dùng khá nhiều
    colorText3: '#FFFFFF', // Cũng dùng khá nhiều
    colorText4: '#000000',
    colorText5: '#FFFFFF',
    colorText6: '#FFFFFF',
    colorText7: '#FF8F1F',
    colorText8: '#FF8F1F',
    colorText9: '#D41800',
    colorText10: '#FFFFFF', // text trạng thái disabled của nút confirm popup recommend
    colorText11: '#FFFFFF', // text trạng thái enabled của nút confirm popup recommend
    colorText12: '#EB4319',
    colorText13: '#FF8F1F',
    starDefault: '#FFE1C2',
    starActive: '#FF8F1F',
  },
  // 2
  {
    name: 'Black',
    nameComponent: 'BlackTheme',
    value: 'black',
    color1: '#000000',
    color2: '#FFFFFF',
    color3: '#FFFFFF',
    color4: '#40ACDD',
    color5: '#FF8F1F',
    color6: '#EB4319',
    color7: '#FFEFDE',
    color8: '#000000',
    color9: '#FFFFFF',
    color10: '#EC6A5F',
    color11: '#FFEFDE',
    color12: '#FF8F1F',
    color13: '#FFEFDE',
    color14: 'rgba(0, 0, 0, 0.1)', // tapped
    color15: '#000000', // icon check
    color16: '#FF8F1F', // Màu nút ở trạng thái active
    color17: '#FFFFFF',
    color18: '#FFE1C2', // Màu khi nút ở trạng thái disabled. Có thể tái sử dụng
    color19: '#34D399',
    color20: '#FF8F1F', // Màu button dùng tại popup recommend
    colorText1: '#FFFFFF',
    colorText2: '#000000',
    colorText3: '#FFFFFF',
    colorText4: '#000000',
    colorText5: '#FFEFDE',
    colorText6: '#FFFFFF',
    colorText7: '#FF8F1F',
    colorText8: '#FF8F1F',
    colorText9: '#EB4319',
    colorText10: '#FFFFFF', // text trạng thái disabled của nút confirm popup recommend
    colorText11: '#FFFFFF', // text trạng thái enabled của nút confirm popup recommend
    colorText12: '#EB4319',
    colorText13: '#FF8F1F',
    starDefault: '#FFE1C2',
    starActive: '#FF8F1F',
  },
  // 3  ******************
  {
    name: 'Mangosteen',
    nameComponent: 'MangosteenTheme',
    value: 'mangosteen',
    color1: '#291750', // base background color
    color2: '#FFFFFF', // màu trạng thái confirmed
    color3: '#000000', // done
    color4: '#E499FF', // màu trạng thái pending
    color5: '#F4C365', // base button order
    color6: '#ED6D6B', //màu trạng thái cancel
    color7: '#A388DD', // màu overlayout image banner
    color8: '#3C2273', // màu cho bgcolor box chọn language introduction
    color9: '#3C2273', // màu cho border box chọn language introduction
    color10: '#FFFFFF', // màu cho text clear all
    color11: '#FFFFFF',
    color12: '#F4C365',
    color13: '#FFFFFF',
    color14: 'rgba(0, 0, 0, 0.1)',
    color15: '#57B360',
    color16: '#F4C365', // Màu nút ở trạng thái active
    color17: '#FFFFFF',
    color18: '#8F6D5B', // Màu khi nút ở trạng thái disabled. Có thể tái sử dụng
    color19: '#65DAF4',
    color20: '#F4C365', // Màu button dùng tại popup recommend
    colorText1: '#FFFFFF', // màu TEXT 1 my cart
    colorText2: '#000000', // màu TEXT 2  order
    colorText3: '#000000', // màu của text order now màn hình your cart
    colorText4: '#FFFFFF', // màu của text title category khi không có ảnh
    colorText5: '#3C2273',
    colorText6: '#000000',
    colorText7: '#F4C365',
    colorText8: '#F4C365',
    colorText9: '#ED6D6B',
    colorText10: '#FFFFFF', // text trạng thái disabled của nút confirm popup recommend
    colorText11: '#000000', // text trạng thái enabled của nút confirm popup recommend
    colorText12: '#ED6D6B',
    colorText13: '#F4C365',
    starDefault: 'rgba(244, 195, 101, 0.5)',
    starActive: 'rgba(244, 195, 101, 1)',
  },
  // 4
  {
    name: 'Red Bean',
    nameComponent: 'RedBeanTheme',
    value: 'red_bean',
    color1: '#501717',
    color2: '#FFFFFF',
    color3: '#FFFFFF',
    color4: '#99C2FF',
    color5: '#B1FDF8',
    color6: '#FF8970',
    color7: '#DD8888',
    color8: '#711F1F',
    color9: '#711F1F',
    color10: '#DD8888',
    color11: '#FFFFFF',
    color12: '#B1FDF8',
    color13: '#FFFFFF',
    color14: 'rgba(0, 0, 0, 0.1)', // tapped
    color15: '#57B360', // icon check
    color16: '#B1FDF8', // Màu nút ở trạng thái active
    color17: '#FFFFFF',
    color18: '#818A88', // Màu khi nút ở trạng thái disabled. Có thể tái sử dụng
    color19: '#FDFAB1',
    color20: '#B1FDF8', // Màu button dùng tại popup recommend
    colorText1: '#FFFFFF',
    colorText2: '#000000',
    colorText3: '#000000',
    colorText4: '#FFFFFF',
    colorText5: '#711F1F',
    colorText6: '#000000',
    colorText7: '#B1FDF8',
    colorText8: '#B1FDF8',
    colorText9: '#E97B65',
    colorText10: '#FFFFFF', // text trạng thái disabled của nút confirm popup recommend
    colorText11: '#000000', // text trạng thái enabled của nút confirm popup recommend
    colorText12: '#E97B65',
    colorText13: '#B1FDF8',
    starDefault: 'rgba(177, 253, 248, 0.5)',
    starActive: 'rgba(177, 253, 248, 1)',
  },
  // ==== THEME TỐI ====
  // 5
  {
    name: 'Mango',
    nameComponent: 'MangoTheme',
    value: 'mango',
    color1: '#FAE0BC',
    color2: '#000000',
    color3: '#FFFFFF',
    color4: '#4646A9',
    color5: '#EF9923',
    color6: '#000000',
    color7: '#F6C889',
    color8: '#F6C889',
    color9: '#F6C889',
    color10: '#EC6A5F',
    color11: '#F6C889',
    color12: '#000000',
    color13: '#FAE5CA',
    color14: 'rgba(246, 200, 137, 0.5)',
    color15: '#000000',
    color16: '#FF8F1F', // Màu nút ở trạng thái active
    color17: '#FFFFFF',
    color18: '#FDB86E', // Màu khi nút ở trạng thái disabled. Có thể tái sử dụng
    color19: '#FF4572',
    color20: '#FF8F1F', // Màu button dùng tại popup recommend
    colorText1: '#000000',
    colorText2: '#FFFFFF',
    colorText3: '#FFFFFF',
    colorText4: '#000000',
    colorText5: '#FDF3E6',
    colorText6: '#FFFFFF',
    colorText7: '#AD45FF',
    colorText8: '#AD45FF',
    colorText9: '#4646A9',
    colorText10: '#FFFFFF', // text trạng thái disabled của nút confirm popup recommend
    colorText11: '#FFFFFF', // text trạng thái enabled của nút confirm popup recommend
    colorText12: '#4646A9',
    colorText13: '#AD45FF',
    starDefault: 'rgba(0, 0, 0, 0.3)',
    starActive: 'rgba(0, 0, 0, 1)',
  },
  // 6
  {
    name: 'Sweet',
    nameComponent: 'SweetTheme',
    value: 'sweet',
    color1: '#FAE1E6',
    color2: '#000000',
    color3: '#FFFFFF',
    color4: '#52977E',
    color5: '#FF5E79',
    color6: '#000000',
    color7: '#F3B2BD',
    color8: '#F2AEBC',
    color9: '#F2AEBC',
    color10: '#000000',
    color11: '#F2AEBC',
    color12: '#000000',
    color13: '#F8D4DB',
    color14: 'rgba(242, 174, 188, 0.5)',
    color15: '#000000',
    color16: '#FF5E79', // Màu nút ở trạng thái active
    color17: '#FFFFFF',
    color18: '#FDA0B0', // Màu khi nút ở trạng thái disabled. Có thể tái sử dụng
    color19: '#6C5297',
    color20: '#FF5E79', // Màu button dùng tại popup recommend
    colorText1: '#000000',
    colorText2: '#FFFFFF',
    colorText3: '#FFFFFF',
    colorText4: '#FFFFFF',
    colorText5: '#F2AEBC',
    colorText6: '#FFFFFF',
    colorText7: '#FF5E79',
    colorText8: '#FF5E79',
    colorText9: '#52977E',
    colorText10: '#FFFFFF', // text trạng thái disabled của nút confirm popup recommend
    colorText11: '#FFFFFF', // text trạng thái enabled của nút confirm popup recommend
    colorText12: '#52977E',
    colorText13: '#FF5E79',
    starDefault: 'rgba(0, 0, 0, 0.3)',
    starActive: 'rgba(0, 0, 0, 1)',
  },
  // 7
  {
    name: 'Blue',
    nameComponent: 'BlueTheme',
    value: 'blue',
    color1: '#ECF3FF',
    color2: '#000000',
    color3: '#FFFFFF',
    color4: '#FF7A00',
    color5: '#00A1C5',
    color6: '#000000',
    color7: '#8CACE5',
    color8: '#AFCCFF',
    color9: '#AFCCFF',
    color10: '#EC6A5F',
    color11: '#AFCCFF',
    color12: '#000000',
    color13: '#DDE9FF',
    color14: 'rgba(175, 204, 255, 0.5)',
    color15: '#000000',
    color16: '#00A1C5', // Màu nút ở trạng thái active
    color17: '#FFFFFF',
    color18: '#76CAE2', // Màu khi nút ở trạng thái disabled. Có thể tái sử dụng
    color19: '#04C500',
    color20: '#00A1C5', // Màu button dùng tại popup recommend
    colorText1: '#000000',
    colorText2: '#FFFFFF',
    colorText3: '#FFFFFF',
    colorText4: '#FFFFFF',
    colorText5: '#AFCCFF',
    colorText6: '#FFFFFF',
    colorText7: '#00A1C5',
    colorText8: '#FF7A00',
    colorText9: '#00A1C5',
    colorText10: '#FFFFFF', // text trạng thái disabled của nút confirm popup recommend
    colorText11: '#FFFFFF', // text trạng thái enabled của nút confirm popup recommend
    colorText12: '#00A1C5',
    colorText13: '#00A1C5',
    starDefault: 'rgba(0, 0, 0, 0.3)',
    starActive: 'rgba(0, 0, 0, 1)',
  },
]

export const THEMES_NAME = {
  default: 'default',
  black: 'black',
  mangosteen: 'mangosteen',
  red_bean: 'red_bean',
  mango: 'mango',
  sweet: 'sweet',
  blue: 'blue',
}

// Định nghĩa các variant cho các button của Mui
export const variantStyles = {
  primary: 'primary',
  secondary: 'secondary',
  btnOrder: 'btnOrder',
  btnAddToOrder: 'btnAddToOrder',
  btnDiscoverForMango: 'btnDiscoverForMango',
}

const { black, mangosteen, red_bean, default: defaultTheme, mango, blue, sweet } = THEMES_NAME

// Định nghĩa các theme được coi là theme tối
export const darkThemeArray = [black, mangosteen, red_bean]

// Định nghĩa các theme được coi là theme sáng
export const lightThemeArray = [defaultTheme, mango, blue, sweet]

// 2 theme tối đặc biệt
export const darkThemeSpecialArr = [mangosteen, red_bean]

/**
 * Lấy ra màu chung dựa vào theme hiện tại.
 * Thông thường theme sáng thì màu sẽ tối (#000)
 * Ngược lại theme tối thì màu sẽ sáng (#fff)
 */
export const getCommonColorByTheme = (currentThemeName) => {
  return darkThemeArray.includes(currentThemeName) ? '#fff' : '#000'
}

/**
 * Lấy ra màu đặc biệt dựa vào theme hiện tại
 * Nếu là theme tối đặc biệt  (#fff)
 * Các theme còn lại sẽ có màu (#000)
 */
export const getColorSpecialByTheme = (currentThemeName) =>
  darkThemeSpecialArr.includes(currentThemeName) ? '#fff' : '#000'
